import { api } from '@/lib/api';

export function useAnalytics() {
  const trackEvent = async (event: string, data?: Record<string, unknown>) => {
    try {
      await api.post('/analytics/events', { event, data });
    } catch {
      // Silent fail — analytics must never block UI
    }
  };

  const trackBatch = async (events: Array<{ event: string; data?: Record<string, unknown> }>) => {
    try {
      await api.post('/analytics/events/batch', { events });
    } catch {
      // Silent fail
    }
  };

  return { trackEvent, trackBatch };
}
